import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.833 2.669c0-.37-.336-.669-.75-.669s-.75.3-.75.669v4.698H2.667c-.369 0-.667.336-.667.75s.298.75.667.75h4.666v4.464c0 .37.336.669.75.669s.75-.3.75-.669V8.867h4.5c.368 0 .667-.336.667-.75s-.299-.75-.667-.75h-4.5z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })